import { useEffect } from "react";
import Radio from "backbone.radio";

import { ensureErrorCallback } from "common/components/error";
import { AuthRoute, useRouteMatch } from "extensions/react-router";

export function DevRouter() {
    const { url } = useRouteMatch();

    return (
        <>
            <AuthRoute path={`${url}/dev/settings`} component={Settings} />
            <AuthRoute path={`${url}/dev/tools`} component={Tools} />
        </>
    );
}

function Settings() {
    useEffect(() => {
        async function settings() {
            try {
                const { SettingsPageRedux } = await import("./settings");
                Radio.channel("main").request("show:app:view", <SettingsPageRedux />, {
                    hideDatePicker: true,
                    waitForAttach: true,
                    name: "Advanced settings"
                });
            } catch (error) {
                ensureErrorCallback(error);
            }
        }

        settings();
    });

    return null;
}

function Tools() {
    useEffect(() => {
        async function tools() {
            const { ToolsView } = await import("./toolsView");
            Radio.channel("main").request("show:app:view", new ToolsView({
                hideDatePicker: true
            }));
        }

        tools();
    });

    return null;
}
